import { useEffect, useState } from "react";
import { useAppSelector } from "src/store/hooks";
// Helpers
import { checkExtension, sendChromeEvent } from "src/helpers";
// Comps
import IcomBtn from "src/components/icom-btn";
export default function ExtensionChat({
  // Methods
  endCall,
  twilioRoomName,
  twilioToken,
}: {
  endCall: Function;
  twilioRoomName: string;
  twilioToken: string;
}) {
  const { callDetails } = useAppSelector((state) => state.call);
  const { accessToken } = useAppSelector((state) => state.auth);
  const [state, setState] = useState({
    darkMode: false,
  });
  const extensionCallBack = async () => {
    endCall(true);
  };
  useEffect(() => {
    async function componentDidMount() {
      const extensionEnabled = await checkExtension();
      if (extensionEnabled) {
        sendChromeEvent(
          {
            type: "SF/JOIN_MEET",
            payload: {
              token: accessToken,
              callDetails: callDetails,
              twilioRoomName,
              twilioToken,
              meetUrl:
                // "https://us04web.zoom.us/j/72266243540?pwd=ehk92ft72LuxMKE9aqes93CQtzgYq5.1",
                "https://meet.google.com/ozh-rygx-nbx",
              // "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NTk3ZTM0N2UtNjY2Yi00MDhmLWFkM2MtOTJkNmE4NjBlZDgw%40thread.v2/0?context=%7b%22Tid%22%3a%22569693de-0d68-493d-8572-feafd1e234cf%22%2c%22Oid%22%3a%22b8ffd971-8e58-44d8-86f8-b51da391efc7%22%7d",
            },
          },
          extensionCallBack
        );
      }
    }
    componentDidMount();
  }, []);
  return (
    <div className={`${state.darkMode && "dark"}  grow flex flex-col`}>
      Chamada proveniente de extensão
      <div>
        <IcomBtn onClick={() => endCall()}>Finalizar</IcomBtn>
      </div>
    </div>
  );
}
